import { StatusEnum } from './status-enum'
import { NotificationReceiver } from './notification-receiver'
import { NotificationReviceRole } from './notification-revice-role'
import { MethodEnum } from './method-enum'
import { UserForegroundDomainEnum } from './user-foreground-domain-enum'

export interface NotificationInterface {
  /**
   * 通知人
   */
  rids?: number[]
  /**
   * 通知状态
   */
  status: StatusEnum
  /**
   * 已读人数
   */
  readedCount?: number
  /**
   * 当前消息接受人
   */
  currentRecever?: NotificationReceiver
  /**
   * 发送人名
   */
  senderName?: string
  /**
   * 接收人角色信息
   */
  receverRoles?: NotificationReviceRole[]
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  /**
   * 通知标题
   */
  title?: string
  /**
   * 活动id
   */
  activityId: number
  /**
   * 通知方法
   */
  method: MethodEnum
  /**
   * 通知人领域
   */
  reflectionDomain: UserForegroundDomainEnum
  /**
   * 发送时间
   */
  publishedAt?: string | null
  /**
   * 通知内容
   */
  content?: string
  /**
   * 撤回理由
   */
  withdrawReason?: string | null
  /**
   * 附件
   */
  attachment?: object
  /**
   * 其它设置
   *  - 活动通知，存储活动ID eg {"activity_id":1}
   */
  setting?: object
}

export class Notification implements NotificationInterface {
  /**
   * 通知人
   */
  rids?: number[]
  /**
   * 通知状态
   */
  status: StatusEnum
  /**
   * 已读人数
   */
  readedCount?: number
  /**
   * 当前消息接受人
   */
  currentRecever?: NotificationReceiver
  /**
   * 发送人名
   */
  senderName?: string
  /**
   * 接收人角色信息
   */
  receverRoles?: NotificationReviceRole[]
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  /**
   * 通知标题
   */
  title?: string
  /**
   * 活动id
   */
  activityId: number
  /**
   * 通知方法
   */
  method: MethodEnum
  /**
   * 通知人领域
   */
  reflectionDomain: UserForegroundDomainEnum
  /**
   * 发送时间
   */
  publishedAt?: string | null
  /**
   * 通知内容
   */
  content?: string
  /**
   * 撤回理由
   */
  withdrawReason?: string | null
  /**
   * 附件
   */
  attachment?: object
  /**
   * 其它设置
   *  - 活动通知，存储活动ID eg {"activity_id":1}
   */
  setting?: object

  constructor(props: NotificationInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      rids: _rids,
      status: _status,
      readedCount: _readedCount,
      currentRecever: _currentRecever,
      senderName: _senderName,
      receverRoles: _receverRoles,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      title: _title,
      activityId: _activityId,
      method: _method,
      reflectionDomain: _reflectionDomain,
      publishedAt: _publishedAt,
      content: _content,
      withdrawReason: _withdrawReason,
      attachment: _attachment,
      setting: _setting,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.rids = _rids
    this.status = _status
    this.readedCount = _readedCount
    this.currentRecever = _currentRecever
      ? new NotificationReceiver(_currentRecever)
      : _currentRecever
    this.senderName = _senderName
    this.receverRoles = _receverRoles
      ? _receverRoles.map((i) => new NotificationReviceRole(i))
      : _receverRoles
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
    this.title = _title
    this.activityId = _activityId
    this.method = _method
    this.reflectionDomain = _reflectionDomain
    this.publishedAt = _publishedAt
    this.content = _content
    this.withdrawReason = _withdrawReason
    this.attachment = _attachment
    this.setting = _setting
  }
}
